import { Component,  Vue } from 'vue-property-decorator';
import store from '@/store';
import router from '@/router';

// 注册组件路由守卫钩子
Component.registerHooks([
  'beforeRouteEnter',
]);

@Component({
    components: {

    },
    filters: {
      Money(val: string) {
        if (val !== null && val !== undefined && val !== '') {
          return '￥' + parseFloat(val).toFixed(2);
        } else {
          return val;
        }
      },
    },
})
export default class Success extends Vue {
  // private $api: any;
  private payedAmount: string = '';

  // 查看消费明细
  private toSpendDetails() {
    this.$router.push('/spend-details');
  }

  // 组件路由前置守卫
  private beforeRouteEnter(to: any, from: any, next: any) {

    // 从vuex中获取当前支付状态
    if (store.state.paySuccessInfo.status === false) {
      // 如果不是支付成功时跳转，则退回上一页面
      router.go(-1);
    }
    next((vm: any)  => {
      // 通过 `vm` 访问组件实例

      // 如果是在支付成功跳转，则获取支付的金额
      vm.payedAmount = vm.$store.state.paySuccessInfo.amount;
    });
  }

}
